import { Guid } from '@web/utils';
import { PaymentMethodCode } from '../../shared/enums/payment-method-code';
import { PublicPaymentMethodProperty } from './public-payment-method-property';

export class PublicCheckoutOrderPaymentMethod {
  public constructor(
    private readonly data: {
      id: Guid;
      code: PaymentMethodCode;
      name: string;
      description: string;
      properties: PublicPaymentMethodProperty[];
    },
  ) {}

  public get id(): Guid {
    return this.data.id;
  }

  public get code(): PaymentMethodCode {
    return this.data.code;
  }

  public get name(): string {
    return this.data.name;
  }

  public get description(): string {
    return this.data.description;
  }

  public get properties(): PublicPaymentMethodProperty[] {
    return this.data.properties;
  }

  public isPayURecursive(): boolean {
    return this.data.code === PaymentMethodCode.PayURecursive;
  }

  public isBankTransfer(): boolean {
    return this.data.code === PaymentMethodCode.BankTransfer;
  }
}
